<template>
  <div class="app-container">
    <BjRouteTabs />
    <PageOrdinaryPackage :set-flag="GOODS_COMBO_TYPES_CSG.ORDINARYCSG" />
  </div>
</template>
<script>
import PageOrdinaryPackage from '../componentsCSG/PageOrdinaryPackage.vue';
import { GOODS_COMBO_TYPES_CSG } from '@/utils/constants';
export default {
  name: 'BusinessGoodsAuditSkuOrdinaryCSGIndex',
  components: {
    PageOrdinaryPackage,
  },
  data() {
    return {
      GOODS_COMBO_TYPES_CSG,
    };
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>